/* eslint-disable react-native/no-inline-styles */
import {Icon, Text} from '@ui-kitten/components';
import React from 'react';
import {View} from 'react-native';

const getRequiredLabel = (label) => {
  return (evaProps) => (
    <View style={{flexDirection: 'row'}}>
      <Text {...evaProps}>{label}</Text>
      <Text {...evaProps} style={[...evaProps.style, {color: 'red'}]}>
        {' *'}
      </Text>
    </View>
  );
};

const AlertIcon = (props) => (
  <Icon fill="red" {...props} name="alert-triangle-outline" />
);

const getErrorText = (error) => {
  if (!error) {
    return undefined;
  }

  return (evaProps) => (
    <Text {...evaProps} status="danger">
      {error}
    </Text>
  );
};

const getErrorIcon = (error) => {
  if (!error) {
    return undefined;
  }

  return AlertIcon;
};

const getFieldStatus = (error) => {
  if (!error) {
    return undefined;
  }

  return 'danger';
};

export const fieldUtils = {
  getErrorText,
  getErrorIcon,
  getFieldStatus,
  getRequiredLabel,
};
